export function buildBackupDownloadUrl(apiBaseUrl, id) {
  return `${apiBaseUrl}/api/Backups/Download?id=${encodeURIComponent(id)}`;
}

export function formatFileSize(bytes) {
  if (typeof bytes !== "number" || !Number.isFinite(bytes) || bytes < 0) {
    return "—";
  }

  const units = ["بایت", "کیلوبایت", "مگابایت", "گیگابایت", "ترابایت"];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }

  const formatted = value.toLocaleString("fa-IR", {
    maximumFractionDigits: unit === 0 ? 0 : 1,
  });
  return `${formatted} ${units[unit]}`;
}

export function extractDownloadFilename(disposition, fallback) {
  if (!disposition) return fallback;

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^["']|["']$/g, ""));
    } catch {
      return utf8Match[1].trim().replace(/^["']|["']$/g, "");
    }
  }

  const plainMatch = disposition.match(/filename=["']?([^"';\n]+)/i);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim();
  }

  return fallback;
}

async function readBlobText(blob) {
  if (typeof blob.text === "function") {
    try {
      const text = await blob.text();
      if (typeof text === "string" && text.length > 0) return text;
    } catch {
      // Some test environments expose Blob without a working text().
    }
  }

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ""));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
}

export async function readBlobErrorMessage(data, fallback) {
  if (!data) return fallback;
  if (typeof data === "string" && data.trim()) return data;
  if (typeof data === "object" && !(data instanceof Blob) && data.message) {
    return data.message;
  }
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      const text = await readBlobText(data);
      const parsed = JSON.parse(text);
      return parsed?.message || parsed?.title || fallback;
    } catch {
      return fallback;
    }
  }
  return fallback;
}
